import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_BEGIN,
  APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_SUCCESS,
  APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_FAILURE,
  APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deleteFigmaTokenDetails(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const { projectId, version } = args;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest =  axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/figma/delete-figma-data`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteFigmaTokenDetailsError() {
  return {
    type: APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteFigmaTokenDetailsPending: true,
        deleteFigmaTokenDetailsError: null,
      };

    case APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteFigmaTokenDetailsPending: false,
        deleteFigmaTokenDetailsError: null,
      };

    case APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteFigmaTokenDetailsPending: false,
        deleteFigmaTokenDetailsError: action.data.error,
      };

    case APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteFigmaTokenDetailsError: null,
      };

    default:
      return state;
  }
}
